export enum BidStatusEnum {
   all,
   winning,
   notWinning,
   won,
   watching
}
